import type { IFiatDropDownOption } from 'BreetComponents';
import { useFormData } from 'BreetHooks';
import { type ReactNode, useMemo, useState } from 'react';

import { CurrencyConverterSchema } from '../DialogCurrencyConverter.helpers';
import { CurrencyConverterContext } from './FormContext';

export const CurrencyConverterProvider = ({ children }: { children?: ReactNode }) => {
	const sendCryptoFormData = useFormData(
		CurrencyConverterSchema,
		{
			amount: '0',
			fromCurrency: 'NGN',
			toCurrency: 'USD',
			toAmount: '0',
		},
		{
			mode: 'onChange',
		}
	);

	const [fromSelectedFiatOption, setFromSelectedFiatOption] = useState<IFiatDropDownOption | undefined>(undefined);
	const [toSelectedFiatOption, setToSelectedFiatOption] = useState<IFiatDropDownOption | undefined>(undefined);

	const providerValue = useMemo(
		() => ({
			formDataContextProps: sendCryptoFormData,
			setFromSelectedFiatOption,
			setToSelectedFiatOption,
			fromSelectedFiatOption,
			toSelectedFiatOption,
		}),
		[sendCryptoFormData, setFromSelectedFiatOption, setToSelectedFiatOption, fromSelectedFiatOption, toSelectedFiatOption]
	);

	return <CurrencyConverterContext.Provider value={providerValue}>{children}</CurrencyConverterContext.Provider>;
};
